export default "__VITE_ASSET__Ci6FBQFB__"